module.exports = __webpack_public_path__ + "c6fa54f7258583408eda0b495b0b816f.png";